import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null=loading, false=logged out, obj=authed
    const [error, setError] = useState("");

    const fetchMe = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            return data;
        } catch (e) {
            setUser(false);
            return false;
        }
    }, []);

    useEffect(() => {
        fetchMe();
    }, [fetchMe]);

    const login = async (email, password) => {
        setError("");
        try {
            const { data } = await api.post("/auth/login", { email, password });
            if (data.access_token) {
                localStorage.setItem("mes_access_token", data.access_token);
            }
            setUser(data.user);
            return data.user;
        } catch (e) {
            const msg = formatApiErrorDetail(e.response?.data?.detail) || e.message;
            setError(msg);
            throw new Error(msg);
        }
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch (e) { /* ignore */ }
        localStorage.removeItem("mes_access_token");
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, error, login, logout, refresh: fetchMe }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}
